import userSettings from "@/components/mixins/user-settings"

export default {
	mixins: [userSettings],
	data() {
		return {
			//moduleName: '',
			totalCount: null,
			keepOffset: false,
			dateFields: [],
			formFields: {
				limit: 50,
				offset: 0,
				search: '',
				sort: {
					column: 'sDateCreated',
					direction: 'asc'
				}
			},
		}
	},
	methods: {
		getFormFields() {
			// keep user on 1st page when filtering - only allow manual pagination
			if (this.keepOffset === false) {
				this.formFields.offset = 0
				this.saveOffset(this.formFields.offset)
			} else {
				this.keepOffset = false
			}

			let formFields = {...this.formFields}

			if (this.dateFields.length > 0) {
				this._.forEach(this.dateFields, (field) => {
					formFields[field] = this.$_date_toTimestamp(formFields[field])
				})
			}

			return formFields
		},
		setLimit(value) {
			this.keepOffset = true
			this.formFields.limit = value
			this.saveLimit(this.formFields.limit)
			this.setOffset(0);
		},
		// OFFSET
		setOffset(value) {
			this.offsetAction(value)
		},
		decreaseOffset() {
			this.offsetAction(this.formFields.offset - this.formFields.limit)
		},
		increaseOffset() {
			this.offsetAction(this.formFields.offset + this.formFields.limit)
		},
		offsetAction(value) {
			this.keepOffset = true
			this.formFields.offset = value
			this.saveOffset(this.formFields.offset)
		},
		// SORTING
		changeSorting(newSort) {
			this.saveSort(newSort)
			this.formFields.sort = newSort
		},
		getActiveSort(column) {
			if (this.formFields.sort.column === column) {
				return this.formFields.sort.direction
			} else {
				return false
			}
		},
		// DEFAULTS
		loadDefaults() {
			let anyChanges = false
			if (this.loadDefaultByKey('sort')) {
				anyChanges = true
			}
			if (this.loadDefaultByKey('search') && this.formFields.search !== '') {
				anyChanges = true
			}
			if (this.loadDefaultByKey('limit') && this.formFields.limit !== 50) {
				anyChanges = true
			}
			if (this.loadDefaultByKey('offset') && this.formFields.offset !== 0) {
				anyChanges = true
			}
			if (this.loadAdditionalDefaults()) {
				anyChanges = true
			}
			return anyChanges
		},
		loadDefaultByKey(settingKey) {
			return this.loadDefaultFromStore(this.formFields, settingKey)
		},
		loadDefaultFromStore(fieldsObject, settingKey) {
			let data = {module: this.moduleName, key: settingKey}
			if (this.$store.getters.hasSetting(data)
			&& fieldsObject.hasOwnProperty(settingKey)
			&& fieldsObject[settingKey] != this.$store.getters.getSetting(data)) {
				fieldsObject[settingKey] = this.$store.getters.getSetting(data)
				return true
			}
			return false
		},
		getDefaultByModuleName(moduleName, settingKey) {
			let data = {module: moduleName, key: settingKey}
			if (this.$store.getters.hasSetting(data)) {
				return this.$store.getters.getSetting(data)
			} else {
				return null
			}
		},
		loadAdditionalDefaults() {
			// specific for each module
			return false
		},
		// SAVING TO STORE
		saveSort(newSettings) {
			this.setUserSetting('sort', newSettings)
		},
		saveSearch(newSettings) {
			this.setUserSetting('search', newSettings)
		},
		saveOffset(newSettings) {
			this.setUserSetting('offset', newSettings)
		},
		saveLimit(newSettings) {
			this.setUserSetting('limit', newSettings)
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/mixins/form-fields.js